import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.SetEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.SetList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.SetCreate })));

export default { edit, list, create };
